import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_INSTALLATION_DEVICE_SLAVE,
  GET_INSTALLATION_DEVICE_SLAVE_SUCCESS,
  GET_INSTALLATION_DEVICE_SLAVE_ERROR,
  UPDATE_INSTALLATION_DEVICE_SLAVE,
  UPDATE_INSTALLATION_DEVICE_SLAVE_SUCCESS,
  UPDATE_INSTALLATION_DEVICE_SLAVE_ERROR,
  ADD_INSTALLATION_DEVICE_SLAVE,
  ADD_INSTALLATION_DEVICE_SLAVE_SUCCESS,
  ADD_INSTALLATION_DEVICE_SLAVE_ERROR,
  DELETE_INSTALLATION_DEVICE_SLAVE,
  DELETE_INSTALLATION_DEVICE_SLAVE_SUCCESS,
  DELETE_INSTALLATION_DEVICE_SLAVE_ERROR,
  REPLACE_INSTALLATION_DEVICE_SLAVE,
  REPLACE_INSTALLATION_DEVICE_SLAVE_SUCCESS,
  REPLACE_INSTALLATION_DEVICE_SLAVE_ERROR,
} from '../../constants/ActionTypes';
/* eslint-disable import/named */
import { deserialize } from '../../models/deviceSlave';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.installationDeviceSlave;
const installationDeviceSlave = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullInstallation' || action.target === 'currentInstallation') {
        return {
          ...state,
          add: { ...initialSettings.add },
          current: { ...initialSettings.current },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
        };
      }
      switch (action.target) {
        case 'addInstallationDeviceSlave':
          key = 'add';
          break;
        case 'updateInstallationDeviceSlave':
          key = 'update';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // GET DEVICE SLAVE
    case GET_INSTALLATION_DEVICE_SLAVE:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_INSTALLATION_DEVICE_SLAVE_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_INSTALLATION_DEVICE_SLAVE_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // UPDATE DEVICE SLAVE
    case UPDATE_INSTALLATION_DEVICE_SLAVE:
      return {
        ...state,
        update: {
          ...state.update,
          error: null,
          updated: false,
          idDevice: action.idDevice,
          idSlave: action.idSlave,
        },
      };
    case UPDATE_INSTALLATION_DEVICE_SLAVE_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_INSTALLATION_DEVICE_SLAVE_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          asyncOperation: action.data.data,
        },
      };
    // ADD DEVICE SLAVE
    case ADD_INSTALLATION_DEVICE_SLAVE:
      return {
        ...state,
        add: {
          ...state.add,
          error: null,
          added: false,
          idDevice: action.idDevice,
        },
      };
    case ADD_INSTALLATION_DEVICE_SLAVE_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_INSTALLATION_DEVICE_SLAVE_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          idSlave: action.data.data.id,
          asyncOperation: action.data.data.async_operation,
        },
      };
    // DELETE DEVICE SLAVE
    case DELETE_INSTALLATION_DEVICE_SLAVE:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: null,
          deleted: false,
          idDevice: action.idDevice,
          idSlave: action.idSlave,
        },
      };
    case DELETE_INSTALLATION_DEVICE_SLAVE_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_INSTALLATION_DEVICE_SLAVE_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    // REPLACE DEVICE SLAVE
    case REPLACE_INSTALLATION_DEVICE_SLAVE:
      return {
        ...state,
        replace: {
          ...state.replace,
          error: null,
          replaced: false,
          idDevice: action.idDevice,
          idNewSlave: action.idNewSlave,
        },
      };
    case REPLACE_INSTALLATION_DEVICE_SLAVE_ERROR:
      return {
        ...state,
        replace: {
          ...state.replace,
          error: action.error,
        },
      };
    case REPLACE_INSTALLATION_DEVICE_SLAVE_SUCCESS:
      return {
        ...state,
        replace: {
          ...state.replace,
          replaced: true,
        },
      };
    default:
      return state;
  }
};

export default installationDeviceSlave;



// WEBPACK FOOTER //
// ./reducers/installation/installationDeviceSlave.js